import { useCallback, useRef, useState } from "react";

// A confirmation that replaces a form keeps at least the form's height, so the
// card does not jump. lock() measures the element as it is now, before the
// swap renders; unlock() lets it size to its content again.
export function useLockedHeight<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [minHeight, setMinHeight] = useState<number | null>(null);
  const lock = useCallback(() => {
    const height = ref.current?.getBoundingClientRect().height ?? 0;
    setMinHeight(height > 0 ? height : null);
  }, []);
  const unlock = useCallback(() => setMinHeight(null), []);
  return { ref, minHeight, lock, unlock };
}
